module.exports = __webpack_public_path__ + "img/title-dver-1-t@3x.ff5f22a5.png";